<mat-dialog-content>
    <div class="container">
      <form flex [formGroup]="recordForm" (ngSubmit)="addNewRecords()">
        <h2 *ngIf="data.record === null">{{ 'NEW_SUBJECT_RECORD.TITLE' | translate }}</h2>
        <h2 *ngIf="data.record !== null">{{ 'NEW_SUBJECT_RECORD.EDIT_RECORD' | translate }}</h2>
        <field-holder>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.PROVIDED_SERVICE' | translate }}</mat-label>
                <mat-select formControlName="providedService" [compareWith]="compareById" required [disabled]="data.record !== null">
                  <mat-option *ngFor="let s of providedServices" [value]="s">
                    {{ s.title }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="recordForm.get('providedService')?.hasError('required')">
                  {{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.PROVIDED_SERVICE_ERROR' | translate }}
                </mat-error>
            </mat-form-field>
        </field-holder>
        <field-holder kind="2-cols">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.RIGHT_GRANTED_DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="rightGrantedDate" formControlName="rightGrantedDate" [max]="maxDate" required>
            <mat-datepicker-toggle matSuffix [for]="rightGrantedDate"></mat-datepicker-toggle>
            <mat-datepicker #rightGrantedDate></mat-datepicker>
            <mat-error *ngIf="recordForm.get('rightGrantedDate').hasError('required')">
              {{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.RIGHT_GRANTED_DATE_ERROR' | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.RIGHT_END_DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="rightEndDate" formControlName="rightEndDate" 
              [min]="minRightEndDate" [max]="maxDate">
            <mat-datepicker-toggle matSuffix [for]="rightEndDate"></mat-datepicker-toggle>
            <mat-datepicker #rightEndDate></mat-datepicker>
          </mat-form-field>
        </field-holder>
        <field-holder kind="2-cols">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.REALIZATION_START_DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="realizationStartDate" formControlName="realizationStartDate" [min]="minRealizationStartDate" [max]="maxRealizationStartDate">
            <mat-datepicker-toggle matSuffix [for]="realizationStartDate"></mat-datepicker-toggle>
            <mat-datepicker #realizationStartDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.REALIZATION_END_DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="realizationEndDate" formControlName="realizationEndDate"
              [min]="minRealizationEndDate" [max]="maxRealizationEndDate">
            <mat-datepicker-toggle matSuffix [for]="realizationEndDate"></mat-datepicker-toggle>
            <mat-datepicker #realizationEndDate></mat-datepicker>
          </mat-form-field>
        </field-holder>
        <field-holder>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.OUTCOME_STATUS' | translate }}
            </mat-label>
            <mat-select formControlName="outcomeStatus">
              <mat-option *ngFor="let s of outcomeStatuses" [value]="s.code">
                {{ s.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </field-holder>
        <field-holder>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.MONTHLY_PRICE' | translate }}</mat-label>
                <input matInput type="number" formControlName="monthlyPrice" min="0">
            </mat-form-field>
        </field-holder>
        <field-holder>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.PAYMENT_METHOD' | translate }}</mat-label>
                <mat-select formControlName="paymentMethod" [compareWith]="compareById">
                  <mat-option></mat-option>
                  <mat-option *ngFor="let p of paymentMethods" [value]="p">
                    {{ p.title }}
                  </mat-option>
                </mat-select>
            </mat-form-field>
        </field-holder>
  
        <form-footer>
          <button mat-stroked-button color="primary" mat-dialog-close (click)="closeDialog()" type="button"
            class="form-footer__button form-footer__button--secondary">
            {{ 'NEW_SUBJECT_RECORD.CANCEL' | translate }}
          </button>
          <button mat-flat-button color="primary" type="submit" class="form-footer__button form-footer__button--primary"
            [disabled]="!recordForm.valid" #submitButton>
            <span *ngIf="data.record === null">
              {{ 'NEW_SUBJECT_RECORD.SUBMIT' | translate }}
            </span>
            <span *ngIf="data.record !== null">
              {{ 'NEW_SUBJECT_RECORD.EDIT_RECORD' | translate }}
            </span>
          </button>
        </form-footer>
      </form>
    </div>
</mat-dialog-content>